import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import { Box, Typography } from "@mui/material";

const EmptyPaymentMethod = () => {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      sx={{ color: "text.secondary", px: 2 }}
    >
      <PaymentsOutlinedIcon sx={{ fontSize: 56, mb: 2, opacity: 0.6 }} />

      <Typography variant="h6" color="text.primary">
        No payments yet
      </Typography>

      <Typography variant="body2" sx={{ mt: 1 }}>
        Payment breakdown will appear after the first successful transaction.
      </Typography>
    </Box>
  );
};

export default EmptyPaymentMethod;
